module.exports = __webpack_public_path__ + "static/media/technical_outline.566d782c.jpeg";